import { QuestionPlanOptionConnectionRoot as Root } from "@/components/features/items/edit/plan/_shared/ui/components/connection/option-connection/root";

import { QuestionPlanRequiredOptionCombinedConnection } from "./combined-required-option-connection";
import { QuestionDayTripPlanOptionConnection } from "./option-connection/option-connection";

export const QuestionPlanOptionConnectionRoot = () => {
	return (
		<Root>
			<QuestionDayTripPlanOptionConnection />
			<QuestionPlanRequiredOptionCombinedConnection />
		</Root>
	);
};

QuestionPlanOptionConnectionRoot.displayName = "QuestionPlanOptionConnectionRoot";
